module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('gmap-map', {
    ref: "map",
    attrs: {
      "id": "map",
      "center": _vm.mapCenter,
      "zoom": _vm.mapZoom,
      "options": _vm.mapOptions
    },
    on: {
      "bounds_changed": _vm.onBoundsChanged
    }
  }, [_vm._l((_vm.monoBrandStores), function(s, i) {
    return _c('gmap-marker', {
      key: i,
      attrs: {
        "position": s.coords,
        "icon": _vm.constructIcon('brand', [24, 36])
      },
      on: {
        "click": function($event) {
          _vm.onMarkerClick(_vm.c)
        }
      }
    })
  }), _vm._v(" "), _vm._l((_vm.clusters), function(c, i) {
    return _c('gmap-marker', {
      key: i,
      attrs: {
        "position": c.coords,
        "label": {
          text: ((c.properties || {}).point_count || ' ').toString(),
          fontSize: '11px'
        },
        "icon": _vm.constructIcon('retailer', [24, 36])
      },
      on: {
        "click": function($event) {
          _vm.onMarkerClick(c)
        }
      }
    })
  }), _vm._v(" "), (_vm.currentPosition) ? _c('gmap-marker', {
    key: _vm.position,
    attrs: {
      "position": {
        lat: _vm.currentPosition.latitude,
        lng: _vm.currentPosition.longitude
      },
      "icon": _vm.constructIcon('location', [16, 16])
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-460015d4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Overview/partials/Map.vue
// module id = 412
// module chunks = 1